export const clientGroupFormDeleteModalId = 'clientGroupFormDeleteModal';
export const clientGroupFormModalId = 'clientGroupFormModal';
export const clientGroupsAlertId = 'clientGroupsAlert';
export const clientGroupsFilterFormId = 'clientGroupsFilterForm';
